export class ImportMismoApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async importMismo({ formData }) {
    return this.#http.post(`/mismo-import/preview`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  async previewApplicationUpdate({ applicationId, formData }) {
    return this.#http.post(`/mismo-import/application/${applicationId}/preview`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  async registerMismo({
    stagingId,
    channelId,
    channelType,
    loanOfficerId,
    roleAssignments,
    edits,
    isTest,
  }) {
    return this.#http.post(`/mismo-import/register`, {
      stagingId,
      channelId,
      channelType,
      loanOfficerId,
      roleAssignments,
      edits,
      isTest,
    });
  }
}
